module.exports = __webpack_public_path__ + "static/media/privacy_logged_in.7a1141f2.png";